import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'vehicles';
const BASE_PATH = `${API_ROOT}/groups`;
const PATHS = {
    CREATE: (groupId, vehicleId) => `${BASE_PATH}/${groupId}/vehicles/${vehicleId}`,
    DELETE: (groupId, vehicleId) => `${BASE_PATH}/${groupId}/vehicles/${vehicleId}`,
    LIST: (groupId) => `${BASE_PATH}/${groupId}/vehicles`,
};
async function create(csrfToken, groupId, vehicleId) {
    return (await (await SecureAxios()).post(PATHS.CREATE(groupId, vehicleId), {}, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, groupId, memberId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(groupId, memberId), { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
async function list(groupId, props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST(groupId)}?${params.toString()}`)).data;
}
function listKey(groupId, props) {
    return [CacheKey, 'list', groupId, props];
}
export default { CacheKey, create, delete_, list, listKey };
